Vendd.Scripts.load(function () {
    var $wrapper = $('.js-filters-wrapper'),
        wrapper,
        $configuration, configuration,
        selectedFiltersUrl = document.URL,
        isAjaxLoad = $wrapper.data('ajax-load') === "True";

    if ($wrapper.length < 1)
        return;

    wrapper = $wrapper.get(0);

    $configuration = $('#configuration', $wrapper);
    configuration = $configuration.text();
    $configuration.remove();

    function UpdateQueryString(key, value, url) {

        if (!url) url = window.location.href;

        // dirty fix for new url rewriter, remove page number to go back to page 1
        url = url.replace(/\/{1}p{1}[0-9]+/, '');


        //Vendd.MessageBus.publishAsync(wrapper, new Vendd.FilterProduct.Messages.GetNextFilter());

        var re = new RegExp("([?|&])" + key + "=.*?(&|#|$)", "gi");

        if (url.match(re)) {
            if (value)
                var value = url.replace(re, '$1' + key + "=" + value + '$2');
            else
                var value = url.replace(re, '$2');

            if (value.indexOf('?') == -1) { // convert first paramter separator to query params separator
                var pos = value.indexOf('&');
                if (pos != -1) // has at least one parameter
                    value = value.substring(0, pos - 1) + '?' + value.substring(pos + 1, value.length);
            }
            return value;
        }
        else {
            if (value) {
                var separator = url.indexOf('?') !== -1 ? '&' : '?',
                    hash = url.split('#');
                url = hash[0] + separator + key + '=' + value;
                if (hash[1]) url += '#' + hash[1];
                return url;
            }
            else
                return url;
        }
    };

    function getQueryStringValueByName(name) {
        name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        var regexS = "[\\?&]" + name + "=([^&#]*)";
        var regex = new RegExp(regexS);
        var results = regex.exec(window.location.search);
        if (results == null)
            return "";
        else
            return decodeURIComponent(results[1].replace(/\+/g, " "));
    };

    function removeValueFromCommaSeparatedString(list, value, separator) {
        separator = separator || ",";
        var values = list.split(separator);
        for (var i = 0; i < values.length; i++) {
            if (values[i] == value.replace(/\s+/g, '-')) {
                values.splice(i, 1);
                return values.join(separator);
            }
        }
        return list;
    };

    function loopThrough() {
        $('.x-control[data-control="filter"][data-type="range"]').each(function (i, rangeFilter) {
            var $wrapper = $(rangeFilter);
            var $slider = $wrapper.find('*[data-slider]');
            var $from = $wrapper.find('input[data-text].from');
            var $to = $wrapper.find('input[data-text].to');

            var isPagerAjax = $wrapper.data('ajax');
            var connectedList = $wrapper.data('list');

            var urlMask = $slider.data('mask');
            urlMask = urlMask.split('?')[1];
            var textMaskFrom = $from.data('mask');
            var textMaskTo = $to.data('mask');

            var minValue = Math.floor($slider.data('min'));
            var maxValue = Math.ceil($slider.data('max'));
            var currentMinValue = Math.floor($slider.data('from'));
            var currentMaxValue = Math.ceil($slider.data('to'));

            $slider.slider({
                range: true,
                min: minValue,
                max: maxValue,
                values: [currentMinValue, currentMaxValue],
                slide: function (event, ui) {
                    $from.val(textMaskFrom.replace("((from))", ui.values[0]));
                    $to.val(textMaskTo.replace("((to))", ui.values[1]));
                },
                stop: function (event, ui) {
                    if (isPagerAjax) {
                        if (connectedList === undefined)
                            throw 'Connected list not declared for filter ' + $wrapper.attr('id');

                        var $connectedList = $('.x-control[data-control="list"][data-list="' + connectedList + '"]').first();

                        var config = $connectedList.get(0).getConfiguration();

                        var filterIdentifier = 'Price';

                        var filter = $.Enumerable.From(config.LoaderData.Filters)
                            .Where(function (x) { return x.Key == filterIdentifier; })
                            .DefaultIfEmpty(null).FirstOrDefault();

                        if (filter === null) {
                            throw 'Filter not found on connected list: ' + filterIdentifier;
                        }
                        if (ui.values[0] === minValue && ui.values[1] === maxValue) {
                            filter.FromValue = null;
                            filter.ToValue = null;
                        }
                        else {
                            filter.FromValue = ui.values[0];
                            filter.ToValue = ui.values[1];
                        }
                        $connectedList.get(0).load(config);
                    }
                    else {
                        var queryNameFrom = 'price-from';
                        var queryValueFrom = ui.values[0];
                        var queryNameTo = 'price-to';
                        var queryValueTo = ui.values[1];
                        selectedFiltersUrl = UpdateQueryString(queryNameFrom, queryValueFrom, selectedFiltersUrl);
                        selectedFiltersUrl = UpdateQueryString(queryNameTo, queryValueTo, selectedFiltersUrl);

                        $('.apply-button', $('.js-filters-wrapper')).addClass('pulse-button');

                        return false;
                    }
                }
            });

            if (isPagerAjax) {
                if (connectedList === undefined)
                    throw 'Connected list not declared for filter ' + $wrapper.attr('id');

                var $list = $('.x-control[data-control="list"][data-list="' + connectedList + '"]').first();
                $list.get(0).bind('dataload', function (control, response) {
                    // here load self to get the new minValue && maxValue!
                    // as a filter, load self with the query of all the rest filters without the self ones!
                });
            }

            $from.val(textMaskFrom.replace("((from))", $slider.slider("values", 0)));
            $to.val(textMaskTo.replace("((to))", $slider.slider("values", 1)));

        });
    }

    function addClickHandlers() {
        // Single Value Allowed
        $('select', $wrapper).sSelect().change(function () {
            var $this = $(this);
            var $selected = $("option:selected", $this);
            var queryName = $selected.attr("data-query");
            var queryValue = $selected.attr("data-value");
            var items = getQueryStringValueByName(queryName);
            selectedFiltersUrl = UpdateQueryString(queryName, queryValue, selectedFiltersUrl);

            if ($wrapper.hasClass('js-auto-submit')) {
                window.location.href = selectedFiltersUrl;
            } else {
                $('.apply-button', $wrapper).addClass('pulse-button')
            }

            return false;
        });

        $(".js-apply-filters").click(function(e) {
            e.preventDefault;
            window.location.href = selectedFiltersUrl;
        });

        $(".js-clear-all").click(function (e) {
			e.preventDefault();
			var url = this.href;
            var href = url.substring(0,url.indexOf('?'))
            if (href) {
                window.location.href = href;
            }else {
                window.location.href = url;
            }
        });


        wrapper.open = function () {
            $('.js-filter-toggle-btn', $wrapper).removeClass('icon-plus2').addClass('icon-minus active');
            $('.js-filter-container',$wrapper).addClass('opened');
        };

        wrapper.close = function () {
            $('.js-filter-toggle-btn', $wrapper).removeClass('icon-minus active').addClass('icon-plus2');
            $('.js-filter-container',$wrapper).removeClass('opened');
        };

        $wrapper.on('click', '.js-filter-toggle-btn', function (e) {
            e.preventDefault();
            var $this = $(this);

            if ($this.hasClass('active')) {
                wrapper.close();
            } else {
                wrapper.open();
            }
        });
    }

    // if ($(window).width() < 960) {
    //     closeExpandedFilters();
    // }

    // $(window).resize(_.debounce(function () {
    //     initFilterExpander();
    // }, 50));

    function initFilterExpander() {
        if ($(window).width() < 960) {
            if (!$wrapper.hasClass('mobile')){
                closeExpandedFilters();
                $wrapper.addClass('mobile');
            }
        } else {
            if ($wrapper.hasClass('mobile')) {
                $('.filter', $wrapper).addClass('expanded').find('.title').removeClass('icon-arrow-down').addClass('icon-arrow-up');
                $wrapper.removeClass('mobile');
            }

        }
    }

    function closeExpandedFilters() {
        $('.filter.expanded', $wrapper).removeClass('expanded').find('.title').removeClass('icon-arrow-up').addClass('icon-arrow-down');
        $wrapper.addClass('mobile');
    }

    function seeMoreToggle(numOfVisible) {
        $('.filters .filter').each(function () {
            if ($(this).find('.twoColumns.wider').children('li').length > numOfVisible) {
                $(this).find(".show-more").addClass('visible');
            }
        });
        $(".filter-toggle-btn").click(function () {
            if ($(this).hasClass('show-more'))
                $(this).removeClass('show-more icon-arrow-down').addClass('show-less icon-arrow-up').closest('.filter').addClass('show-all');
            else {
                $(this).removeClass('show-less icon-arrow-up').addClass('show-more icon-arrow-down').closest('.filter').removeClass('show-all');
            }
        });
    }

    if (isAjaxLoad) {

        var model = null;
        wrapper.loading = function loading(loading) {
            if (loading) {
                $wrapper.addClass('x-loading');
            } else {
                $wrapper.removeClass('x-loading');
            };
        };

        wrapper.update = function update() {
            wrapper.loading(true);

            var html = Vendd.Handlebars.parse("filters", JSON.parse(model));
            wrapper.bind(html, model);

            loopThrough();
            addClickHandlers();

            wrapper.loading(false);
        };


        wrapper.bind = function bind(html, bindModel) {
            $wrapper.html(html);
        };


        Vendd.MessageBus.subscribe(Vendd.FilterProduct.Messages.Changed, wrapper, function (envelope) {
            model = envelope.message.data;
            wrapper.update();
        });

        Vendd.MessageBus.subscribe(Vendd.FilterProduct.Messages.Failed, wrapper, function (envelope) {
            wrapper.loading(false);
        });

        //Vendd.MessageBus.subscribe(Vendd.FilterProduct.Messages.ShowMessages, wrapper, function (envelope) {

        //    var messages = envelope.message.data.resultMessages;
        //    if (messages.length > 0) {
        //        var message = messages.join('\n');
        //        alert(message);
        //    }
        //});

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.FilterProduct.Messages.GetModel(configuration));

    } else {

        loopThrough();

        addClickHandlers();

        // seeMoreToggle(12);

    }

});

